import type { RouteRecordName } from 'vue-router';

export default function mapListToColumns(
  routeName: RouteRecordName | null | undefined,
  columns: string[] | undefined,
  mainDataRoute: RouteRecordName | undefined,
  activityRoute: RouteRecordName | undefined,
  trackerRoute: RouteRecordName | undefined,
): string[] | [] {
  if (!columns) {
    return [];
  }

  switch (routeName) {
    case mainDataRoute:

      return columns.filter((key) => !['serial_id', 'history_of_players_changes', 'registrationdate', 'date_of_first_deposit', 'date_of_last_activity'].includes(key));
    case activityRoute:
      return columns.filter((key) => ['registrationdate', 'date_of_first_deposit', 'date_of_last_activity'].includes(key));
    case trackerRoute:
      return columns.filter((key) => ['anid'].includes(key));
    default:
      return [];
  }
}
